import type { IOrganizationWorkspaceResource } from 'packages/workspace/modules/algebra/interfaces/IOrganizationWorkspaceResource';
import { useMutation, UseMutationResult, useQuery } from 'react-query';
import { Http } from '../../modules/prelude/http';
import type { ResponseFormat } from '../models/global-models';

//Calling URL Directly here since its Unprotected function.
export const getWorkspaceInfo = async (domain: string): Promise<IOrganizationWorkspaceResource> => {
  const data = await Http.Request<ResponseFormat<IOrganizationWorkspaceResource>>('GET', `/workspaces/api/v1/authn.discovery?url=${domain}`, undefined, false);
  return data.data;
};

export const useDiscoveryParams = (host: string) => {
  return useQuery(['authn.discovery'], () => getWorkspaceInfo(host), {
    staleTime: Infinity,
  });
};

export const useLogoutLogs = (): UseMutationResult<string, unknown, { tag: string }, unknown> => {
  return useMutation(async ({ tag }) => Http.Request<ResponseFormat<string>>('GET', `/workspaces/api/v1/logout-logs.create?tag=${tag}`).then((res) => res.data));
};
